export default "__VITE_ASSET__5824c947__"